import { ruPlural } from '@/lib/content/declension';

/**
 * UI-тексты виджетов жилья (accommodation): карточки отелей, удобства,
 * тематические подборки, сетка типов жилья, карта отелей города.
 * Только вертикаль-специфика; общие надзаголовки/якоря/теги — в servicePage.
 *
 * Интерполируемые строки — функции. Названия городов уже склоняет компонент
 * и передаёт сюда готовыми (cityDisplayName).
 *
 * AMENITY_LABELS: key → локализованная подпись удобства (плоский объект на язык,
 * порядок/фильтрацию делает HotelCard.amenitiesFor через AMENITY_ORDER).
 */
export const accommodationUi = {
    en: {
        // CityHotels — секция «Проверенные отели» на странице города
        cityHotels: {
            eyebrow: (city) => `${city}. Hotels`,
            title: 'Hand-picked hotels',
            allLabel: 'All options',
            lead: 'A curated selection with fair prices, amenities and direct booking.',
            showMore: (n) => `Show ${n} more`,
            findMore: 'Find more options',
            searchBooking: 'Search on Booking.com',
            searchTrip: 'Search on Trip.com',
        },
        // CityHotelsMap — карта отелей города
        map: {
            layer: 'Hotels',
            panelEyebrow: 'Hotels on the map',
            hint: 'Tap a hotel — the map zooms to it',
            ariaLabel: 'City hotels map',
            kmUnit: (km) => `${km} km`,
        },
        // ThematicCollections — тематические подборки (блог)
        thematic: {
            eyebrow: 'Collections',
            title: 'Thematic collections',
            lead: 'Curated collections of places to stay.',
            open: 'Open',
        },
        // StayTypesGrid — сетка/блок типов жилья
        types: {
            count: (n) => `// ${n} ${n === 1 ? 'type' : 'types'}`,
            view: 'View',
        },
        // HotelCard — карточка отеля
        card: {
            reviews: (n) => (n === 1 ? 'review' : 'reviews'),
            stars: (n) => (n === 1 ? 'star' : 'stars'),
            toCentre: (km) => `${km} km to centre`,
            checkBooking: 'Check price on Booking.com',
            checkTrip: 'Check price on Trip.com',
        },
        // AMENITY_LABELS — подписи удобств (порядок задаёт AMENITY_ORDER в HotelCard)
        amenities: {
            spa: 'Spa',
            pool: 'Pool',
            beach: 'Private beach',
            seaFront: 'Seafront',
            breakfast: 'Breakfast',
            fitness: 'Gym',
            parkingFree: 'Free parking',
            parking: 'Parking',
            family: 'Family',
            ruStaff: 'Russian-speaking staff',
            pets: 'Pet friendly',
        },
    },
    ru: {
        cityHotels: {
            eyebrow: (city) => `${city}. Отели`,
            title: 'Проверенные отели',
            allLabel: 'Все варианты',
            lead: 'Подборка отелей с честными ценами, удобствами и прямым бронированием.',
            showMore: (n) => `Показать ещё ${n}`,
            findMore: 'Искать ещё варианты',
            searchBooking: 'Искать на Booking.com',
            searchTrip: 'Искать на Trip.com',
        },
        map: {
            layer: 'Отели',
            panelEyebrow: 'Отели на карте',
            hint: 'Нажмите отель — карта приблизит точку',
            ariaLabel: 'Карта отелей города',
            kmUnit: (km) => `${km} км`,
        },
        thematic: {
            eyebrow: 'Тематические подборки',
            title: 'Тематические подборки',
            lead: 'Уникальные подборки вариантов для проживания.',
            open: 'Открыть',
        },
        types: {
            count: (n) => `// ${n} ${ruPlural(n, ['тип', 'типа', 'типов'])}`,
            view: 'Смотреть',
        },
        card: {
            reviews: (n) => ruPlural(n, ['отзыв', 'отзыва', 'отзывов']),
            stars: (n) => ruPlural(n, ['звезда', 'звезды', 'звёзд']),
            toCentre: (km) => `${km} км до центра`,
            checkBooking: 'Проверить цену на Booking.com',
            checkTrip: 'Проверить цену на Trip.com',
        },
        amenities: {
            spa: 'Спа',
            pool: 'Бассейн',
            beach: 'Свой пляж',
            seaFront: 'Первая линия',
            breakfast: 'Завтрак',
            fitness: 'Фитнес',
            parkingFree: 'Беспл. парковка',
            parking: 'Парковка',
            family: 'Для семей',
            ruStaff: 'Русскоговорящий персонал',
            pets: 'С питомцами',
        },
    },
};
